export function isCheckValueAndSetParams (params, value) {
    if (typeof (value) === 'undefined' || value === null || value === '' || value === 'NaN') {
        return '';
    }
    return params + value;
}
